import { ListItem } from './types';

interface UseCheckboxProps {
  list: ListItem[];
  checkedIdList?: string[];
  setCheckedIdList?: (checkedIdList: string[]) => void;
}
interface UseCheckbox {
  checkboxAllStatus: 'checked' | 'unchecked' | 'indeterminate';
  updateCheckbox: (checked: boolean, id: string) => void;
  updateCheckboxAll: (checked: boolean) => void;
}
const useCheckbox = (props: UseCheckboxProps): UseCheckbox => {
  const { list, checkedIdList, setCheckedIdList } = props;

  const getCheckboxAllStatus = () => {
    if (!checkedIdList || checkedIdList.length === 0 || list.length === 0) return 'unchecked';
    else if (checkedIdList.length === list.length) return 'checked';
    return 'indeterminate';
  };

  const updateCheckbox = (checked: boolean, id: string) => {
    if (!setCheckedIdList || !checkedIdList) return;

    if (checked) {
      setCheckedIdList([...checkedIdList, id]);
    } else {
      setCheckedIdList(checkedIdList.filter((checkedId) => checkedId !== id));
    }
  };

  const updateCheckboxAll = (checked: boolean) => {
    if (!setCheckedIdList || !checkedIdList) return;

    if (checked) {
      const allList = list.map((item) => item.id);
      setCheckedIdList(allList);
    } else {
      setCheckedIdList([]);
    }
  };

  return {
    checkboxAllStatus: getCheckboxAllStatus(),
    updateCheckbox,
    updateCheckboxAll,
  };
};

export default useCheckbox;
